import { useTranslation } from "react-i18next"

import { CONFIRMATION_OVERLAY } from "shared/context/overlay/types"
import { useEvent } from "shared/lib/useEvent"
import { useOverlay } from "shared/lib/useOverlay"

import { useResendTeamMemberInvitation } from "entities/team-members/api/useResendTeamMemberInvitation"
import { getTeamMemberDisplayName } from "entities/team-members/model/getTeamMemberDisplayName"
import { useTeamMemberMutations } from "entities/team-members/model/useTeamMemberMutations"

import {
  DeleteTeamMemberHandler,
  TeamMemberActionHandlers
} from "../types/TeamMemberActionHandlers"

export function useTeamMemberActionHandlers(): TeamMemberActionHandlers {
  const { t } = useTranslation()
  const { deleteTeamMember } = useTeamMemberMutations()
  const { resendTeamMemberInvitation } = useResendTeamMemberInvitation()
  const { openOverlay: openConfirmationOverlay } =
    useOverlay(CONFIRMATION_OVERLAY)

  const handleDeleteTeamMember: DeleteTeamMemberHandler = useEvent(
    ({ teamMember, teamID }) => {
      openConfirmationOverlay({
        id: "confirm-delete-team-member",
        headline: t("Team.Member.DeleteConfirmation.Title"),
        message: t("Team.Member.DeleteConfirmation.Message", {
          member: getTeamMemberDisplayName(teamMember)
        }),
        isDanger: true,
        confirmButtonText: t("General.Delete"),
        onConfirm: () =>
          deleteTeamMember?.({ teamID, teamMemberID: teamMember.id })
      })
    }
  )

  return {
    handleDeleteTeamMember,
    handleResendTeamMemberInvitation: resendTeamMemberInvitation
  }
}
